import s from './style.css';
import Container from 'components/Container';
import Logo from 'components/Logo';

const Footer = ({ sourceTitle, sourceText }) => (
	<div className={s.footer}>
		<Container>
			<p className={s.logo}>
				<Logo trim />
			</p>
			<p>
				<strong>{sourceTitle}</strong> <br />
				{sourceText}
			</p>
			<p>
				Created in collaboration with{' '}
				<a
					href="https://beyondwordsstudio.com/?utm_source=totaljobs-covering-footer"
					target="_blank"
					rel="noopener noreferrer"
				>
					Beyond Words Studio
				</a>
				.
			</p>
		</Container>
	</div>
);

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js